// Esito riconciliazione col registro Eureka (round 2, punto 1):
// ✓ verde = numero+data+totale coerenti; ✗ rosso = divergenza; ? = numero
// non trovato nella serie. Nessun badge = mai riconciliata / registro indietro.
import type { Proposal } from "../types";

export function EurekaCheckBadge({ proposal }: { proposal: Proposal }) {
  const check = proposal.eureka_check ?? null;
  if (!check) return null;
  if (check === "ok") {
    const tot =
      proposal.tot_ivato_verified != null
        ? ` €${Number(proposal.tot_ivato_verified).toFixed(2)}`
        : "";
    return (
      <span
        className="ml-1 inline-flex items-center rounded bg-emerald-500/15 px-1 py-px text-[10.5px] font-medium text-emerald-700"
        title={`Riscontrata nel registro Eureka${tot}`}
      >
        ✓ Eureka{tot}
      </span>
    );
  }
  if (check.startsWith("mismatch")) {
    const campi = check.split(":")[1] ?? "";
    const attesa =
      proposal.tot_ivato_verified != null
        ? ` Eureka ha €${Number(proposal.tot_ivato_verified).toFixed(2)}.`
        : "";
    return (
      <span
        className="ml-1 inline-flex items-center rounded bg-rose-500/15 px-1 py-px text-[10.5px] font-semibold text-rose-700"
        title={`Divergenza col registro Eureka su: ${campi || "dati"}.${attesa}`}
      >
        ✗ Eureka ({campi || "dati"})
      </span>
    );
  }
  // non_trovato
  return (
    <span
      className="ml-1 inline-flex items-center rounded bg-orange-500/15 px-1 py-px text-[10.5px] font-semibold text-orange-700"
      title="Numero documento NON trovato nella serie del registro Eureka"
    >
      ? non in Eureka
    </span>
  );
}
